/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./walletDetail.vue?vue&type=template&id=3264585b&scoped=true"
import script from "./walletDetail.vue?vue&type=script&lang=js"
export * from "./walletDetail.vue?vue&type=script&lang=js"
import style1 from "./walletDetail.vue?vue&type=style&index=1&id=3264585b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3264585b",
  null
  
)

export default component.exports